var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2a1 1 0 011 1v.171a3.001 3.001 0 010 5.658V21a1 1 0 11-2 0V8.83a3.001 3.001 0 010-5.66V3a1 1 0 011-1zm7 0a1 1 0 011 1v10.171a3.001 3.001 0 010 5.658V21a1 1 0 11-2 0v-2.17a3.001 3.001 0 010-5.66V3a1 1 0 011-1zm7 0a1 1 0 011 1v4.171a3.001 3.001 0 010 5.658V21a1 1 0 11-2 0v-8.17a3.001 3.001 0 010-5.66V3a1 1 0 011-1zm-7 13a1 1 0 100 2 1 1 0 000-2zm7-6a1 1 0 100 2 1 1 0 000-2zM5 5a1 1 0 100 2 1 1 0 000-2z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "55f8ad6b9f558896697f50c5d7f81a2d.svg";
export { SvgSettings as ReactComponent };